<template>
  <a
    :href="href"
    @click.prevent="open"
  >
    <slot />
  </a>
</template>

<script>
import isBlank from 'is-blank'

export default {
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    isExternal () {
      return this.post.external && !isBlank(this.post.source.url)
    },
    href () {
      return this.isExternal
        ? this.post.source.url
        : this.$router.resolve({ name: 'ContentPage', params: { contentId: this.post.id } }).href
    }
  },
  methods: {
    open () {
      this.isExternal
        ? window.open(this.post.source.url, '_blank')
        : this.$router.push({ name: 'ContentPage', params: { contentId: this.post.id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/posts/PostLink.vue